// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__BTjPM","column":"dashboard_column__Bqndi","row":"dashboard_row__FJHPw","hot_message":"dashboard_hot_message__hgjQz"};